<template>
  <div class="the-map">
    <!-- <div style="width:260px;height:30px">经度：{{lng}} 纬度：{{lat}}</div> -->
    <div class="map-container" id="map-container"></div>
  </div>
</template>

<script>
import _ from "lodash";
import Bus from "@/api/bus";
import mapUtil from "@/api/mapUtil";
import { mapGetters } from "vuex";

export default {
  name: "TheMap",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    showInfoWin: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    data: function(newVal) {
      const that = this;
      that.map.clearMap();
      if (that.centerMarker) {
        that.map.add(that.centerMarker);
      }
      if (newVal) {
        that.initMarkers();
        if (that.isFitView || newVal.length > 10) {
          mapUtil.$location.fitView();
        }
      }
    },
    isHideMarkerInfo(newVal) {
      const that = this;
      newVal ? that.hideInfo() : that.showInfo();
    }
  },
  mounted() {
    const that = this;
    that.initMap();
    window.goThere = data => {
      that.$emit("showNav", data);
    };
  },
  data() {
    return {
      driving: null,
      markerList: [],
      infoList: [],
      centerMarker: null,
      lat:localStorage.getItem('lat'),
      lng:localStorage.getItem('lng')
    };
  },
  computed: {
    ...mapGetters(["isHideMarkerInfo", "isFitView"]),
    map() {
      return this.$store.getters.mapObject;
    }
  },
  methods: {
    initMap() {
      const that = this;
      mapUtil.initMap();
      that.initMarkers();
    },
    //新增方法
    create(data, isHideMarkerInfo) {
      let that = this;
      mapUtil.$marker.createMarkers(data, isHideMarkerInfo);
    },
    initMarkers() {
      const that = this;
      that.markerList = mapUtil.$marker.createMarkers(
        that.data,
        that.isHideMarkerInfo
      );
      mapUtil.$marker.addPlenty(that.markerList);
      // 添加多个信息窗口
      that.infoList = mapUtil.$marker.createInfo(that.data);
      console.log(that.data)
      mapUtil.$marker.addPlenty(that.infoList);

      // that.$store.commit('setDataList', that.data)
      // that.$store.commit('setMarkerList', that.markerList)
      // that.$store.commit('setInfoList', that.infoList)

      // 点击标记显示弹窗
      const len = that.data.length;
      for (let i = 0; i < len; i++) {
        that.markerList[i].on("click", function(e) {
          that.activeMarker(that.data[i]);
          that.$emit("selectMarker", that.data[i]);
        });
      }
    },
    showInfo() {
      let that = this;
      mapUtil.$marker.normalize(that.data, that.markerList, that.infoList);
    },
    hideInfo() {
      let that = this;
      mapUtil.$marker.hideInfo(that.data, that.markerList, that.infoList);
    },
    activeMarker(data) {
      let that = this;
      if (!data) {
        return false;
      }
      that.$store.commit("setIsFitView", true);
      mapUtil.$marker.active(data, that.data, that.markerList, that.infoList);
    },
    disactiveMarkers() {
      let that = this;
      mapUtil.$marker.normalize(
        that.data,
        that.markerList,
        that.infoList,
        that.isHideMarkerInfo
      );
    },
    clearRoute() {
      mapUtil.$route.removeAll();
    },
    startDraw(code, data, startLngLat, endLngLat) {
      let that = this;
      if (data.location) {
        console.log("经纬度",startLngLat,endLngLat)
        mapUtil.$route.draw(code, startLngLat, endLngLat);
        //  mapUtil.$marker.active(data, that.data, that.markerList, that.infoList);
      } else {
        mapUtil.$route.draw(code, startLngLat, endLngLat);
        mapUtil.$marker.active(data, that.data, that.markerList, that.infoList);
      }
    },
    clearDraw() {
      mapUtil.clear();
    },
    fitView() {
      mapUtil.$location.fitView();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.the-map {
  position: relative;
  width: 100%;
  height: 100%;
  .map-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
::v-deep {
  .map-marker {
    position: relative;
    width: 40px;
    height: 40px;
    line-height: 32px;
    text-align: center;
    // background: url(require("/assets/images/pin.png")) ;
    .marker-bg {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 40px;
      color: #427af4;
    }
    .marker-icon {
      position: relative;
      font-size: 16px;
      color: #fff;
      vertical-align: top;
    }
    &.active,
    &:hover {
      .marker-bg {
        color: #f8412d;
      }
    }
  }
  .map-info {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 0;
    background: #fff;
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(103, 103, 103, 0.5);
    &:after {
      position: absolute;
      content: "";
      bottom: -7px;
      left: 0;
      right: 0;
      width: 7px;
      margin: 0 auto;
      border-top: 7px #fff solid;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }
    .info {
      padding: 0 $paddingHorizontal;
      text-align: center;
      vertical-align: top;
    }
    .icon {
      padding: 0 $paddingHorizontal;
      text-align: center;
      cursor: pointer;
      vertical-align: top;
      border-left: 1px solid $borderColorPrimary;
      i {
        display: block;
        margin: 0 auto;
        width: 24px;
        height: 24px;
        background: url("~@img/map/go.png") center/contain no-repeat;
      }
      span {
        font-size: 12px;
      }
      &:hover {
        color: $colorPrimary;
      }
    }
  }
  .amap-maps {
    .amap-marker-label {
      display: none;
      width: 120px;
      padding: 4px 16px;
      font-size: 12px;
      line-height: $lineHeight;
      text-align: center;
      white-space: normal;
      background: #ffffff;
      border: none;
      border-radius: 4px;
      box-shadow: 0 2px 6px 0 rgba(103, 103, 103, 0.5);
      &:after {
        position: absolute;
        content: "";
        bottom: -7px;
        left: calc(50% - 8px);
        border-top: 7px #fff solid;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
      }
    }
  }
}
</style>
